//import NProgress from 'nprogress';
//import 'nprogress/nprogress.css';
import store from './store'
/*const progressShowDelay = 100;
let routeResolved = false;
/**
 * Initializes NProgress after a specified delay only if the route was not resolved yet.
 

function cancelTopProgress() {
  routeResolved = true;
  NProgress.done();
}
function tryInitProgress() {
  routeResolved = false;
  setTimeout(()=> {
    if (!routeResolved) {
      NProgress.start();
    }
  }, progressShowDelay);
}*/

var rutas_cargadas = [];

const initProgress = (router) => {

  router.beforeEach((to, from, next)=>{
    console.log("Rutas", rutas_cargadas)
    console.log("To name ", to.name)
    if(!to.name){
      store.commit('ASIGNA_CARGANDO_COMPONENTE', false)
    }
    if(!rutas_cargadas.includes(to.name) && to.name){
      store.commit('ASIGNA_CARGANDO_COMPONENTE', true)
      setTimeout(() =>{if(to.name!==undefined){rutas_cargadas.push(to.name)}}, 300);
    } else {
      store.commit('ASIGNA_CARGANDO_COMPONENTE', false)
    }
    next()
  })
  router.afterEach((to, from) => {
    if(!rutas_cargadas.includes(to.name)){
      console.log("La ruta tarda en cargarse")
      //store.commit('ASIGNA_CARGANDO_COMPONENTE', false)
      setTimeout(() => store.commit('ASIGNA_CARGANDO_COMPONENTE', false),400)
    } else {
      store.commit('ASIGNA_CARGANDO_COMPONENTE', false)
    }
  })
  router.beforeResolve((to, from, next) => {
  next()
  })

}



export {
  initProgress,
}


// WEBPACK FOOTER //
// ./src/progressbar.js